<template>
  <el-container>
    <!-- 主体内容 -->
    <el-header
      style="display: flex; align-items: center; justify-content: space-between"
    >
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>工单办理详情</el-breadcrumb-item>
      </el-breadcrumb>
      <el-button-group>
        <el-button type="info" icon="el-icon-eleme" @click.native="browser()"
          >舆情来源</el-button
        >
        <el-button
          v-if="
            data.pst.status == -2 ||
            data.pst.status == 0 ||
            data.pst.status == 2 ||
            data.pst.status == 3
          "
          type="info"
          icon="el-icon-position"
          @click.native="toTansfer()"
          >{{ transferBtnCaption }}</el-button
        >
        <el-button
          type="info"
          icon="el-icon-arrow-left"
          @click.native="formReturn()"
          >返 回</el-button
        ></el-button-group
      >
    </el-header>
    <el-main>
      <div>
        <el-tabs type="card" :tab-position="tabPosition">
          <el-tab-pane key="0">
            <span slot="label"><i class="el-icon-date"></i> 舆情信息</span>
            <el-form
              :model="data.pst"
              ref="pstRef"
              status-icon
              label-width="100px"
            >
              <el-form-item label="录入单位" prop="unitName">
                <el-input v-model="data.pst.unitName" disabled />
              </el-form-item>
              <el-form-item label="录入人" prop="userName">
                <el-input v-model="data.pst.userName" disabled />
              </el-form-item>
              <el-form-item label="舆情类别" prop="pstType">
                <el-input v-model="data.pstTypeName" disabled />
              </el-form-item>
              <el-form-item label="发贴标题" prop="title">
                <el-input v-model="data.pst.title" disabled />
              </el-form-item>
              <el-form-item label="发贴人" prop="name">
                <el-input v-model="data.pst.name" disabled />
              </el-form-item>
              <el-form-item label="发贴时间" prop="postingTime">
                <el-input v-model="data.pst.postingTime" disabled />
              </el-form-item>
              <el-form-item label="来源" prop="pstSource">
                <el-input v-model="data.pst.pstSource" disabled />
              </el-form-item>
              <el-form-item label="贴子内容" prop="pstContent">
                <el-input
                  type="textarea"
                  :rows="10"
                  v-model="data.pst.pstContent"
                  disabled
                />
              </el-form-item>
              <el-form-item label="状态" prop="statusName">
                <el-input v-model="data.statusName" disabled />
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane v-for="node in data.nodes" :key="node.id">
            <span slot="label"
              ><i :class="pstApi.getStatusIcon(node.status)"></i>
              {{ pstApi.getNodeTitle(node.status) }}</span
            >
            <el-form :model="node" status-icon label-width="100px">
              <el-form-item label="办理单位" v-if="node.unitName">
                <el-input v-model="node.unitName" disabled />
              </el-form-item>
              <el-form-item label="办理人">
                <el-input v-model="node.userName" disabled />
              </el-form-item>
              <el-form-item label="转办单位" v-if="node.status == 1">
                <el-input v-model="node.transferUnitName" disabled />
              </el-form-item>
              <el-form-item
                label="相关单位"
                v-if="node.status == -1 && node.transferUnitId != '00000000-0000-0000-0000-000000000000'"
              >
                <el-input v-model="node.transferUnitName" disabled />
              </el-form-item>
              <el-form-item label="答复信息" v-if="node.nodeContent.length > 0">
                <el-input
                  type="textarea"
                  :rows="2"
                  v-model="node.nodeContent"
                  disabled
                />
              </el-form-item>
              <el-form-item label="提交信息" v-if="node.nodeMessage">
                <el-input
                  type="textarea"
                  :rows="node.status == 2 ? 15 : 2"
                  v-model="node.nodeMessage"
                  disabled
                />
              </el-form-item>
              <el-form-item :label="pstApi.getTimeTitle(node.status)">
                <el-input
                  :value="
                    node.lastTime
                      ? Common.dateFormatter(node.lastTime, 'yyyy-MM-dd hh:mm')
                      : ''
                  "
                  disabled
                />
              </el-form-item>
              <el-form-item label="佐证材料" v-if="node.uploadCount > 0">
                <el-card class="box-card">
                  <!-- 文件上传组件 -->
                  <upload :nodeId="node.id" :disabled="true" />
                </el-card>
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import upload from "../../../components/Contents.vue";
export default {
  components: {
    upload,
  },
  created() {
    this.data.pst.id = this.$route.params.id;
    this.getPst(); //读取舆情  信息
  },
  data() {
    return {
      tabPosition: "right",
      transferBtnCaption: "",
      //数据项
      data: {
        statusName: "",
        pstTypeName: "",
        pst: {
          id: "",
        },
        nodes: [],
      },
    };
  },
  methods: {
    //读取舆情信息
    getPst() {
      let pstId = this.data.pst.id;
      this.pstApi
        .getPstInfo(pstId)
        .then((res) => {
          var data = res.data;
          // console.log(data)
          this.data.pst = data;
          if (data.status == -2) {
            this.transferBtnCaption = "去审查";
          } else if (data.status == 0 || data.status == 3) {
            this.transferBtnCaption = "去转办";
          } else if (data.status == 2) {
            this.transferBtnCaption = "答复审核";
          }
          this.data.statusName = this.pstApi.getStatusTransferTitle(
            data.status
          );
          this.data.pstTypeName = this.pstApi.getPstTypeName(data.pstType);
          this.data.nodes = data.nodeInfos;
          //
          // console.log(data.pstContent)
          this.data.pst.pstContent=this.Common.convertChars(data.pstContent);
        })
        .catch((err) => {
          this.$message.error("读取失败");
        });
    },
    formReturn() {
      this.$router.back();
    },
    browser() {
      window.open(this.data.pst.pstUrl, "_blank");
    },
    toTansfer() {
      if (this.data.pst.status == -2) {
        this.$router.push({
          name: "PstAudit",
          params: { id: this.data.pst.id },
        });
      } else if (this.data.pst.status == 0 || this.data.pst.status == 3) {
        this.$router.push({
          name: "Transfer",
          params: { id: this.data.pst.id },
        });
      } else if (this.data.pst.status == 2) {
        this.$router.push({
          name: "ReplyAudit",
          params: { id: this.data.pst.id },
        });
      }
    },
  },
};
</script>
  
<style lang="less" scoped>
.el-header {
  background-color: #b3c0d1;
  color: #333;
  line-height: 40px;
}
//工具栏样式
.cust_seach {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  width: 100%;
  padding: auto 5px;
  .btnLeft {
    flex: 1;
    margin: 0;
    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }
  }
  .btnTitle {
    flex: 2;
    margin: 0;
    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
    }
  }
  .btnStatus {
    flex: 1;
    margin: 0;
    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-right-radius: 0px;
      border-bottom-right-radius: 0px;
    }
  }
  .el-button-group > .el-button:first-child:last-child {
    border-radius: 0px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
}
.el-select {
  float: left;
}
.cust_pagin {
  display: flex;
  position: sticky;
  bottom: 0;
  z-index: 999;
}
/deep/.el-breadcrumb__separator {
  color: rgb(87, 86, 86);
}
/deep/.el-textarea.is-disabled .el-textarea__inner {
  background-color: #fff;
  border-color: #e4e7ed;
  color: #031944;
  cursor: auto;
}
/deep/.el-input.is-disabled .el-input__inner {
  background-color: #fff;
  border-color: #e4e7ed;
  color: #031944;
  cursor: auto;
}
</style>